const Divider = (props: any) => {
    return (
        <>
            <section className="container">
                <div className="section-header">
                    <div className="title-wrapper">
                        <span className="title-line"></span>
                        <h2 className="h6 fw-bold">
                            {props.title}
                        </h2>
                    </div>

                    <div className="divider d-md-inline-block d-nonenp"></div>

                    <button className="btn btn-outline-primary rounded-pill font-medium-lg">
                        {props.subtitile}
                    </button>
                </div>
            </section>
        </>
    )
}

export default Divider;